import React, { useState } from "react";
// import "./App.css";
import ImageInput from "./ImageInput";
// import Default_User_Pic from  "./defaultUserPic.svg";
const imageList=[
  {image:'images/gallery/1.jpg', count:'12'},
  {image:'images/gallery/2.jpg', count:'12'},
  // {image:'images/gallery/3.jpg', count:'12'},
  // {image:'images/gallery/4.jpg', count:'12'},
  // {image:'images/gallery/3.jpg', count:'12'},
  
]
const imgArray=[{name:'',count:''}]
const MainCropper = () => {
  const [image, setImage] = useState("");
  return (
    <div className="col image-input">
      <ImageInput
        imageDataDemo={imgArray}
        imageData={imageList}
        defaultPic={'images/gallery/1.jpg'}
        // defaultPic={Default_User_Pic}
        type="admin"
        name="photo"
        label="Add Photo"
        showPreview
        onChange={(files) => setImage(files, "admin")}
      />
    </div>
  );
};

export default MainCropper;
